export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=2.5"},{"name":"description","content":"86BET\n           - Trang web cá cược bóng đá uy tín số 1 tại VN. Nhà cái tỷ lệ kèo cá cược bóng đá, lô đề online.\n           Link vào BONG88 trực tiếp 2024"},{"property":"og:title","content":"86BET – Nhà cái cá cược bóng đá, kèo bóng đá trực tuyến 2024"},{"property":"og:description","content":"86BET\n           - Trang web cá cược bóng đá uy tín số 1 tại VN. Nhà cái tỷ lệ kèo cá cược bóng đá, lô đề online.\n           Link vào BONG88 trực tiếp 2024"},{"name":"google-site-verification","content":"L4ydHNSVIcXG0SM96W3_xHfbxUk_YqqiHcJ8hhfSZ3s"},{"name":"dmca-site-verification","content":"WkovU0pYdUVzN1kyWWg1bEtvSkVvQT090"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"canonical","href":"https://86bet.net/"},{"key":"mdi","rel":"stylesheet","href":"https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css","type":"text/css","crossorigin":"anonymous"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"vi"},"title":"86BET – Nhà cái cá cược bóng đá, kèo bóng đá trực tuyến 2024"}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appLayoutTransition = {"name":"layout","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000